import React from 'react';
import {usePages} from "@ignitesales/neuro-application";

const ProgressBar = () => {
  const componentClass = 'progressBar';
  const { progress } = usePages();
  const progressValue = Math.round(progress.total);

  return <div className={componentClass} role="progressbar" aria-valuenow={progress.total || 1} aria-valuemin="0" aria-valuemax="100">
      <div className={`${componentClass}__indicator`}>
          {progressValue}%
      </div>
      <div className={`${componentClass}__wrapper`}>
          <div className={`${componentClass}__status`} style={{width: `${progress.total || 1}%`}}/>
      </div>
  </div>;
};

export default ProgressBar;
